import { useMediaQuery } from '@vueuse/core'
import type { ComputedRef } from 'vue'

/**
 * The one narrow-screen breakpoint HQ uses. It is the same value the sidebar already switches on
 * (`SidebarProvider` renders its off-canvas drawer under it), so a phone gets the stacked tables,
 * the graph list fallbacks and the drawer together instead of at three different widths.
 */
export const MOBILE_MEDIA_QUERY = '(max-width: 768px)'

/** True while the viewport is at or under the shared mobile breakpoint (a phone, e.g. 390px). */
export function useIsMobile(): ComputedRef<boolean> {
    return useMediaQuery(MOBILE_MEDIA_QUERY)
}
